import {
  REFRESH_TOKEN,
  ACCESS_TOKEN,
  USER,
  IS_URL_TOKEN,
} from '@wajeez-web/core/utils';
import { SetUser, User } from '../types';

function getLocalRefreshToken() {
  const refreshToken: string = localStorage.getItem(REFRESH_TOKEN) ?? '';
  return refreshToken;
}

function getLocalAccessToken() {
  const token: string = localStorage.getItem(ACCESS_TOKEN) ?? '';
  return token;
}

function getIsUrlToken() {
  const isUrlToken = localStorage.getItem(IS_URL_TOKEN) === 'true';
  return isUrlToken;
}

function updateLocalAccessToken(token: string) {
  localStorage.setItem(ACCESS_TOKEN, token);
}

function updateIsUrlToken(value: boolean) {
  localStorage.setItem(IS_URL_TOKEN, value + '');
}

function getUser() {
  return JSON.parse(localStorage.getItem(USER) || ' {}');
}

function updateUser(data: User) {
  localStorage.setItem(USER, JSON.stringify(data));
}

function setUser(data: SetUser) {
  data.user && localStorage.setItem(USER, JSON.stringify(data.user));
  localStorage.setItem(ACCESS_TOKEN, data.token);
  localStorage.setItem(REFRESH_TOKEN, data.refreshToken);
}

function removeUser() {
  const adminView = localStorage.getItem('admin-view');
  const darkModeSetting = localStorage.getItem('dark-mode-setting');

  localStorage.clear();

  adminView && localStorage.setItem('admin-view', adminView);
  darkModeSetting && localStorage.setItem('dark-mode-setting', darkModeSetting);
}

function removeAuth() {
  localStorage.removeItem(USER);
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
}

export {
  getLocalAccessToken,
  getLocalRefreshToken,
  getIsUrlToken,
  updateLocalAccessToken,
  updateIsUrlToken,
  getUser,
  setUser,
  updateUser,
  removeUser,
  removeAuth,
};
